/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addToFetchDenylist} from '../api'

export const useMutationAddToFetchDenylist = createReactQueryMutationHook('addToFetchDenylist', addToFetchDenylist)
